export default __webpack_public_path__ + "static/media/right-tick.60016531.svg";